import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core'
import { interval, map, Observable } from 'rxjs'
import { GbTimerHelper, TimeRemainingView } from './gb-timer-helper.service'

@Component({
  selector: 'gb-timer',
  templateUrl: './gb-timer.component.html',
  styleUrls: ['./gb-timer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbTimerComponent implements OnInit {
  // Date timer counting down to
  @Input() endDate: Date | undefined | null
  // Number of seconds prior to timer end to show warnings
  @Input() warningSeconds = 10
  // Interval of time between get time remaining
  @Input() interval = 1000
  // Display timer header
  @Input() title = ''
  // Display time remaining in text or card format
  @Input() isCardView = false
  // If timer should blink when ending
  @Input() animateOnTimerEnding = true
  // Message to display when timer has ended
  @Input() timerEndMessage?: string

  timeRemaining$!: Observable<TimeRemainingView[]>
  isTimerEnding$!: Observable<boolean>
  hasTimerEnded$!: Observable<boolean>

  /**
   * Always display two digits if card format
   * i.e. '01' hours (shows leading zero)
   */
  get digitsInfo(): string {
    return this.isCardView ? '2.0' : '1.0'
  }

  get timerClass(): string {
    return this.isCardView ? 'card' : 'text'
  }

  getEndDate(): Date | undefined {
    return this.endDate ? this.endDate : undefined
  }

  constructor(private gbTimerHelper: GbTimerHelper) {}

  ngOnInit(): void {
    this.gbTimerHelper.setWarningSeconds(this.warningSeconds)

    this.timeRemaining$ = interval(this.interval).pipe(
      map(() => this.gbTimerHelper.getTimeRemaining(this.getEndDate(), this.isCardView)),
    )

    this.isTimerEnding$ = this.gbTimerHelper.getIsTimerEnding()
    this.hasTimerEnded$ = this.gbTimerHelper.getHasTimerEnded()
  }
}
